import { get } from 'lodash';
import detectRoute, {
  POST_PAGE,
  CATEGORIES_PAGE,
  FEED_PAGE,
  SEARCH_RESULTS,
  POST_EDIT_PAGE,
} from '../services/detect-route';

import {
  getReferrer,
  getCurrentOrigin,
  POST_LIMITER_VALUES,
  getReportType,
  getOriginFromAppSectionParams,
  getGuidelinesType,
  getTabNameByFeedType,
  getCreatePostOrigin,
  getCreatePostCTAOrigin,
  getBasicCreatePostCTAOrigin,
  feedTypeToTabName,
  getPinDurationValue,
  ReactionCodeBIMap,
} from './bi-helpers';
import { actionsOpened } from '../actions/actions-opened';
import {
  buttonClicked,
  ButtonClickedAction,
  ButtonClickedBadges,
  ButtonClickedImageExpand,
  ButtonClickedLoginToComment,
  ButtonClickedMarkAsBestAnswer,
  ButtonClickedOnPost,
  ButtonClickedReactionsCount,
  ButtonClickedToggleSuggestions,
} from '../actions/button-clicked';
import { changePage } from '../actions/change-page';
import { NAVIGATE_WITHIN_FORUM } from '../../common/actions/navigate-within-forum';
import { createPostRequest, CreatePostSuccess, createPostSuccess } from '../actions/create-post';
import { deleteCategorySuccess } from '../actions/delete-category';
import { deletePostSuccess } from '../actions/delete-post';
import { fetchSearchSuccess } from '../actions/fetch-search';
import { pageOpened } from '../actions/page-opened';
import { subscribeSuccess, SUBSCRIBE_SUCCESS } from '../actions/subscribe';
import { interactionError } from '../../common/interactions/interactions.actions';
import { unsubscribeSuccess } from '../actions/unsubscribe';
import { updatePostRequest, UpdatePostSuccess, updatePostSuccess } from '../actions/update-post';
import { reportPostSuccess } from '../actions/report-post';
import { getCategoryBySlug, getCategory } from '../../common/selectors/categories-selectors';
import { getPrevPath } from '../../common/store/location/location-selectors';
import { getPostBySlug, getPost } from '../selectors/post-selectors';

import { setPostsPageSorting, setSearchPageSorting } from '../actions/set-sorting';
import { setPostTypeFilter } from '../actions/set-filter';
import {
  getPreviousMatches,
  getRouteParams,
  getCurrentMatch,
  getRouteQueryParams,
} from '../../common/router/router-selectors';
import { isOwner } from '../../common/store/current-user/current-user-selectors';
import { setHasReportedAppLoaded } from '../../common/store/app-loaded/app-loaded-actions';
import { fileDownloadRequest } from '../actions/file-upload-bi-actions';
import { POST_LIMIT_REACHED } from '../components/messages/message-types';
import { showMessage } from '../../common/messages/framework/store/message-actions';
import { setSavedAction } from '../../common/store/saved-action/set-saved-action';
import { getIsPostingDisabled, getPostLimiter } from '../selectors/forum-data-selectors';
import {
  userEventsClickPublish,
  userEventsShowEmptyState,
  userEventsClickProfileLink,
  userEventsClickCreatePost,
  userEventsClickCreatePostButton,
  userEventsClickCreatePostButtonNoCategory,
  userEventsSelectCategoryOnCreatePost,
  userEventsPostCaptchaShown,
  userEventsPostCaptchaResolved,
  userEventsCommentCaptchaShown,
  userEventsCommentCaptchaResolved,
  userEventsGuidelinesShown,
  userEventsPostingDisabledShown,
  userEventsPostingDisabledClose,
  userEventsSearchFocused,
  userEventsSearchCleared,
  userEventsSearchSuggestionsLoaded,
  userEventsSearchSubmitted,
  userEventsClickReaction,
  userEventsPostPendingModalShown,
  userEventsPostPendingModalClose,
} from '../actions/user-events';
import { getIsMainPageEnabled } from '../selectors/app-settings-selectors';
import { getEntity, getTotalPages, getEntityCount } from '../selectors/pagination-selectors';
import { getCommentsPerPage, getPostPageSize } from '../constants/pagination';
import { getIsMobile } from '../../common/store/basic-params/basic-params-selectors';
import { REACT_TO_POST } from '../constants/interactions';
import { FILTER_SHOW_ALL } from '../constants/filtering';
import { INVALID_APP_STATE_PAGE } from '../constants/page-names';
import {
  getCategoryPostType,
  getImageCount,
  getFileCount,
  getHashtagCount,
  getGifCount,
  getPollCount,
  getEmojiCount,
  getMentionCount,
  getQuoteCount,
  getVideoCount,
  hasCustomVideo,
} from '@wix/communities-forum-client-commons';
import { getSearchResultsCurrentPage } from '../selectors/search-selectors';
import {
  appFullyLoaded,
  createPostIntent,
  followPostClick,
  followCategoryClick,
  paginationClick,
  searchResults,
  goToProfileClick,
  postDeleted,
  createPostClick,
  clickOnCategory,
  clickOnPost,
  actionButtonActionClick,
  actionButtonLogInSignUp,
  categoriesClickOnCreateBadgeRolePaidPlan,
  forumImageExpand,
  cogwheelMenuOpened,
  whoLikedPostClick,
  markAsBestClick,
  toggleAutoSuggest,
  reportPost,
  postPageOpened,
  editPostPostEditingWindowOpened,
  mainPageOpened,
  postListOpened,
  searchPageSearchPageOpened,
  customErrorPageRendered,
  postPublished,
  likePublished,
  editingPostWindowPublishPostClick,
  actionButtonOpenActions,
  postSortInCategory,
  fileDownloaded,
  postLimitReached,
  emptyStateShown,
  likeClicked,
  attemptToPublishPost,
  postFilter,
  captchaOnPostPublish,
  clickOnShowHideGuidelines,
  shownGuidelines,
  forumTabClick,
  readOnlyMessageShown,
  clickOnSearchField,
  clickInSearchFieldX,
  searchTabDropListShowed,
  clickSeeAllResultsInSearchField,
  categoriesCategoryDeleted,
  chooseACategoryWarning,
  selectACategoryClick,
  actionButtonPinPostConfirmationClick,
  newPostSubmittedForApproval,
  postApprovalModalWindowOpen,
  postApprovalModalWindowClosed,
} from '@wix/bi-logger-forums-uou/v2';
import { hideGuidelinesSuccess, showGuidelinesSuccess } from '../actions/guidelines';
import {
  CATEGORY_GUIDELINES,
  FORUM_GUIDELINES,
  getDisplayGuidelinesTypeFromStore,
} from '../selectors/guidelines-selectors';

import { decodeQuery } from '../services/query-encoding';
import {
  FeedType,
  getFeedType,
  getTabsReferrer,
  getTabsOrigin,
  navigateToMainPageStart,
} from '../containers/header-navigation';
import { BiEventsExecutor } from './bi-types';
import { createActionMatcher } from './create-bi-action-matcher';
import { setRouterMatch } from '../../common/router/router-actions';
import { Comment } from '@wix/ambassador-forum-v1-comment/types';
import { RootState } from '../types/store-types';
import { SearchResultComment } from '../types';
import { getIsPostNew } from '../containers/user-activity/user-activity.selectors';
import { isPostSeen } from '../services/post-utils';
import { pinPostRequest } from '../actions/pin-post';
import { reactToPostSuccess } from '../containers/post-reactions/post-reactions-actions';
import { ReactionCode } from '@wix/comments-ooi-client/reaction-types';

export const uouBiEventsExecutor = ({
  action: outerAction,
  state,
  logger,
  biLocation,
  isSite,
  config,
  viewerSessionId,
}: BiEventsExecutor<AllActions, RootState>) => {
  createActionMatcher<AllActions>(state, logger)
    .match(
      [setHasReportedAppLoaded],
      () => {
        return isSite ? appFullyLoaded : undefined;
      },
      () => {
        return { vsi: viewerSessionId };
      },
    )
    .match(
      [userEventsClickCreatePostButton],
      () => createPostIntent,
      () => {
        return {
          origin: 'live',
        };
      },
    )
    .match(
      [userEventsClickCreatePostButtonNoCategory],
      () => chooseACategoryWarning,
      (action) => {
        return {
          post_title: action.payload.postTitle,
          origin: 'live_create_post',
        };
      },
    )
    .match(
      [userEventsSelectCategoryOnCreatePost],
      () => selectACategoryClick,
      (action) => {
        return {
          id: action.payload.id,
          origin: 'live_create_post',
          flag: !!action.payload.hasTriedSubmitting,
        };
      },
    )
    .match(
      [subscribeSuccess],
      (action) => {
        if (action.payload.type === 'post') {
          return followPostClick;
        }
        if (action.payload.type === 'category') {
          return followCategoryClick;
        }
        return;
      },
      (action) => {
        if (action.payload.type === 'post') {
          return {
            flag: true,
            post_followed: action.payload._id,
            posts_format: getPost(state, action.payload._id).postType,
            origin: biLocation.get(SUBSCRIBE_SUCCESS) || getCurrentOrigin(state),
          };
        }

        const category = getCategory(state, action.payload._id);
        return {
          flag: true,
          type: 'follow',
          posts_format: getCategoryPostType(category),
          origin: getCurrentOrigin(state),
        };
      },
    )
    .match(
      [unsubscribeSuccess],
      (action) => {
        if (action.payload.type === 'post') {
          return followPostClick;
        }
        if (action.payload.type === 'category') {
          return followCategoryClick;
        }
        return;
      },
      (action) => {
        const origin = biLocation.get(SUBSCRIBE_SUCCESS) || getCurrentOrigin(state);
        if (action.payload.type === 'post') {
          return {
            flag: false,
            post_followed: action.payload._id,
            posts_format: getPost(state, action.payload._id).postType,
            origin,
          };
        }

        const category = getCategory(state, action.payload._id);
        return {
          flag: false,
          type: 'follow',
          posts_format: getCategoryPostType(category),
          origin: getCurrentOrigin(state),
        };
      },
    )
    .match(
      [changePage],
      (action) => {
        const buttonType = get(action.payload, 'meta.bi.buttonType');
        if (buttonType) {
          return paginationClick;
        }
      },
      (action) => {
        const buttonType = get(action.payload, 'meta.bi.buttonType');
        return {
          page_destination: action.payload.page,
          button_type: buttonType,
          origin: getCurrentOrigin(state),
        };
      },
    )
    .match(
      [fetchSearchSuccess],
      () => searchResults,
      (action) => {
        return {
          origin: feedTypeToTabName(getTabsReferrer(state, 1)) || getCurrentOrigin(state), // TODO: after release when searching 2nd time in search page it should show search page
          referral_info: 'direct',
          search_term: decodeQuery(decodeURIComponent(getRouteParams(state)?.query || '')),
          result_count_posts: action.payload.posts.length,
          result_count_members: action.payload.users.length,
        };
      },
    )
    .match(
      [userEventsClickProfileLink],
      () => goToProfileClick,
      (action) => {
        return {
          origin: getCurrentOrigin(state),
          is_my_profile: action.payload.isOwnProfile,
        };
      },
    )
    .match(
      [deletePostSuccess],
      () => postDeleted,
      (action) => {
        const categorySlug = getRouteParams(state).categorySlug;
        const category = categorySlug
          ? getCategoryBySlug(state, categorySlug)
          : getCategory(state, getPost(state, action.payload)?.categoryId);
        return {
          post_id: action.payload,
          category_posts_format: getCategoryPostType(category),
          is_admin: isOwner(state),
          origin: 'live',
        };
      },
    )
    .match(
      [deleteCategorySuccess],
      () => categoriesCategoryDeleted,
      (action) => {
        return {
          category_id: action.payload,
          origin: 'live',
        };
      },
    )
    .match(
      [userEventsClickCreatePost],
      () => createPostClick,
      (action) => {
        return {
          posts_format: action.payload,
          origin: getCreatePostCTAOrigin(state),
          cta_origin: getBasicCreatePostCTAOrigin(state, true),
        };
      },
    )
    .match(
      [setRouterMatch],
      (action) => {
        const prevMatches = getPreviousMatches(state);
        const isInitialLoad = prevMatches.length === 0;

        if (isInitialLoad) {
          return;
        }
        const routeParams = action.payload.params;

        const { categorySlug, postSlug } = routeParams;
        const prevMatchParams = prevMatches && prevMatches.length > 0 && prevMatches[1].params;
        if (
          categorySlug &&
          postSlug &&
          prevMatchParams.categorySlug === categorySlug &&
          prevMatchParams.postSlug === postSlug
        ) {
          return;
        }

        const prevPath = getPrevPath(state);
        const path = action.payload.pathname;
        const route = detectRoute(path);

        if (route === FEED_PAGE) {
          const category = getCategoryBySlug(state, categorySlug);
          if (category) {
            return clickOnCategory;
          }
        }

        if (prevPath && route === POST_PAGE) {
          return clickOnPost;
        }
      },
      (action) => {
        const { categorySlug, postSlug, query } = action.payload.params;
        const prevPath = getPrevPath(state);
        const path = action.payload.pathname;
        const route = detectRoute(path);
        const biOrigin = biLocation.get(NAVIGATE_WITHIN_FORUM);
        const origin = biOrigin || detectRoute(prevPath);

        if (route === FEED_PAGE) {
          const category = getCategoryBySlug(state, categorySlug);
          if (category) {
            return {
              category_id: category._id,
              category_slug: category.slug,
              origin,
              main_display_type: getIsMainPageEnabled(state, config.style)
                ? 'list_of_categories'
                : 'list_of_posts',
            };
          }
        }
        const post = getPostBySlug(state, postSlug);

        if (post) {
          const search_term = detectRoute(prevPath) === SEARCH_RESULTS ? query : null;
          const isNew = getIsPostNew(state)(post._id);
          const isSeen = isPostSeen(post);

          return {
            post_id: post._id,
            post_slug: postSlug,
            origin: biOrigin || feedTypeToTabName(getTabsReferrer(state, 1)) || origin,
            search_term,
            is_new: isNew,
            is_read: isSeen,
          };
        }
      },
    )
    // !! Couldn't figure out the types needed to be able to match more
    // !! than 4 functions and their params. A workaround works by
    // !! giving a callback that creates the LogObject here.
    .match(
      [buttonClicked],
      (action) => {
        const origin = getCurrentOrigin(state);
        switch (action.payload.name) {
          case 'click_similar_post':
            const clickSimilarPostPayload = action.payload as ButtonClickedOnPost;
            const isNew = getIsPostNew(state)(clickSimilarPostPayload._id);
            const isSeen = isPostSeen(clickSimilarPostPayload);
            return () =>
              clickOnPost({
                post_id: clickSimilarPostPayload._id,
                post_name: clickSimilarPostPayload.title,
                post_slug: clickSimilarPostPayload.slug,
                search_term: clickSimilarPostPayload.term,
                origin: clickSimilarPostPayload.origin,
                type: 'post',
                is_new: isNew,
                is_read: isSeen,
              });
          case 'click_external_resource':
            const clickExternalResourcePayload = action.payload as ButtonClickedOnPost;
            return () =>
              clickOnPost({
                post_name: clickExternalResourcePayload.title,
                post_slug: clickExternalResourcePayload.slug,
                search_term: clickExternalResourcePayload.term,
                origin: clickExternalResourcePayload.origin,
                type: 'external_link',
              });
          case 'action_click':
            const actionClickPayload = action.payload as ButtonClickedAction;
            const category =
              actionClickPayload.categoryId && getCategory(state, actionClickPayload.categoryId);

            return () =>
              actionButtonActionClick({
                post_id: actionClickPayload.postId,
                category_posts_format: category ? getCategoryPostType(category) : '',
                origin: feedTypeToTabName(getTabsOrigin(state)) || origin,
                type: actionClickPayload.type,
                action: actionClickPayload.action,
                flag: !!actionClickPayload.flag,
              });
          case 'log_in_to_comment':
            const logInToCommentPayload = action.payload as ButtonClickedLoginToComment;
            return () =>
              actionButtonLogInSignUp({
                type: logInToCommentPayload.type,
              });
          case 'create_badge_category_manager':
          case 'manage_badge_category_manager': {
            const categoryManagerPayload = action.payload as ButtonClickedBadges;
            const category = getCategory(state, categoryManagerPayload.id);
            return () =>
              categoriesClickOnCreateBadgeRolePaidPlan({
                button_name: categoryManagerPayload.name,
                category_id: categoryManagerPayload.id,
                posts_format: getCategoryPostType(category),
                origin: 'categoriesManager',
              });
          }
          case 'img_expand': {
            const imgExpandPayload = action.payload as ButtonClickedImageExpand;
            const { params } = getCurrentMatch(state);
            const post = getPostBySlug(state, params.postSlug);

            return () =>
              forumImageExpand({
                type: imgExpandPayload.origin,
                post_id: get(post, '_id'),
                category_id: get(post, 'categoryId'),
              });
          }
          case 'categories_settings_cog': {
            return () => cogwheelMenuOpened({});
          }
          case 'reactions_list': {
            const reactionsListPayload = action.payload as ButtonClickedReactionsCount;
            const { postId, reactionType } = reactionsListPayload;

            return () =>
              whoLikedPostClick({
                type: 'post',
                origin: feedTypeToTabName(getTabsOrigin(state)) || getCurrentOrigin(state),
                post_id: postId,
                reaction_type: reactionType,
              });
          }
          case 'mark_as_best_answer':
            const markAsBestAnswerPayload = action.payload as ButtonClickedMarkAsBestAnswer;
            return () =>
              markAsBestClick({
                flag: markAsBestAnswerPayload.isMarked,
                origin: markAsBestAnswerPayload.origin,
                post_id: markAsBestAnswerPayload.postId,
                comment_id: markAsBestAnswerPayload.commentId,
              });
          case 'toggle_suggestions':
            const toggleSuggestionsPayload = action.payload as ButtonClickedToggleSuggestions;
            return () =>
              toggleAutoSuggest({
                flag: toggleSuggestionsPayload.isEnabled,
                category_id: toggleSuggestionsPayload.categoryId,
              });
          default:
            throw new Error();
        }
      },
      () => {
        return {};
      },
    )
    .match(
      [reportPostSuccess],
      () => reportPost,
      (action) => {
        return {
          post_id: action.payload._id,
          type: 'post',
          origin: getCurrentOrigin(state),
          action: getReportType(action.payload.reportType),
        };
      },
    )
    .match(
      [pageOpened],
      (action) => {
        const feedType = getFeedType(state);
        const main_display_type =
          feedType === FeedType.MyPosts
            ? 'list_of_my_posts'
            : action.payload.isMainPageEnabled
            ? 'list_of_categories'
            : 'list_of_posts';
        const biOrigin = biLocation.get(NAVIGATE_WITHIN_FORUM);
        const origin = biOrigin || getReferrer(state) || getOriginFromAppSectionParams(state);

        switch (action.payload.page) {
          case POST_PAGE:
            const post = action.payload.post;
            let origin_page_nr: number;
            if (origin === SEARCH_RESULTS) {
              origin_page_nr = getSearchResultsCurrentPage(state, getIsMobile(state));
            } else if (origin === FEED_PAGE) {
              const entityPagination = getEntity(state, 'posts', post.categoryId) || {};
              const pages = entityPagination.entitiesByPage || [];
              origin_page_nr =
                // @ts-expect-error
                Object.keys(pages).find((index) =>
                  pages[index].find((entityId: string) => entityId === post._id),
                ) as number;
            }
            const isNew = post.isNew;
            const isSeen = isPostSeen(post);
            return () =>
              postPageOpened({
                post_id: post._id,
                type: action.payload.page,
                post_slug: post.title,
                posts_format: post.postType,
                origin:
                  biOrigin ||
                  feedTypeToTabName(getTabsReferrer(state)) ||
                  action.payload.origin ||
                  origin,
                search_term:
                  getReferrer(state) === SEARCH_RESULTS
                    ? getRouteParams(state).query
                    : getRouteQueryParams(state)?.searchTerm || null,
                total_pages: getTotalPages(
                  state,
                  'comments',
                  post._id,
                  getCommentsPerPage(getIsMobile(state)),
                ) as number,
                origin_page_nr,
                is_new: isNew,
                is_read: isSeen,
              });
          case POST_EDIT_PAGE:
            return () => editPostPostEditingWindowOpened({});
          case CATEGORIES_PAGE:
            return isSite
              ? () =>
                  mainPageOpened({
                    origin: (feedTypeToTabName(getTabsReferrer(state)) as string) || origin,
                    main_display_type,
                    is_disabled_posting: getIsPostingDisabled(state) as boolean,
                  })
              : undefined;
          case FEED_PAGE:
            return isSite
              ? () =>
                  postListOpened({
                    origin,
                    category_id: action.payload.category._id,
                    category_slug: action.payload.category.slug,
                    main_display_type,
                    total_posts: getEntityCount(
                      state,
                      'posts',
                      action.payload.category._id,
                    ) as number,
                    total_pages: getTotalPages(
                      state,
                      'posts',
                      action.payload.category._id,
                      getPostPageSize(state, state),
                    ) as number,
                  })
              : undefined;
          case SEARCH_RESULTS:
            return () => searchPageSearchPageOpened({});
          case INVALID_APP_STATE_PAGE:
            return () => customErrorPageRendered({});
          default:
            throw new Error();
        }
      },
      () => {
        return {};
      },
    )
    .match(
      [createPostSuccess],
      (action) => (action.payload.draft ? newPostSubmittedForApproval : postPublished),
      (action) => createContentEntityData(action, state, 'post', false),
    )
    .match(
      [updatePostSuccess],
      () => postPublished,
      (action) => createContentEntityData(action, state, 'post', true),
    )
    .match(
      [reactToPostSuccess],
      () => likePublished,
      (action) => {
        const { subaction, _id, reactionCode } = action.payload;
        return {
          post_id: _id,
          reaction_type: ReactionCodeBIMap[reactionCode],
          flag: subaction !== 'REMOVE',
          action: subaction.toLocaleLowerCase(),
          type: 'post',
          origin: feedTypeToTabName(getTabsOrigin(state)) || getCurrentOrigin(state),
        };
      },
    )
    .match(
      [updatePostRequest, createPostRequest],
      () => editingPostWindowPublishPostClick,
      () => {
        return {};
      },
    )
    .match(
      [actionsOpened],
      () => actionButtonOpenActions,
      (action) => {
        return {
          type: action.payload.type,
          origin: getCurrentOrigin(state),
        };
      },
    )
    .match(
      [setPostsPageSorting],
      (action) => {
        const dontReportBi = get(action, 'meta.dontReportBI');
        if (dontReportBi) {
          return;
        }
        return postSortInCategory;
      },
      (action) => {
        const categorySlug = getRouteParams(state).categorySlug;
        const category = getCategoryBySlug(state, categorySlug);

        return {
          sort_by: action.payload,
          category_id: category ? category._id : null,
          origin: 'posts_page',
          application_type: 'web',
        };
      },
    )
    .match(
      [setSearchPageSorting],
      (action) => postSortInCategory,
      (action) => {
        return {
          sort_by: action.payload,
          category_id: '',
          origin: 'search',
          application_type: 'web',
        };
      },
    )
    .match(
      [fileDownloadRequest],
      () => fileDownloaded,
      (action) => {
        return {
          application_type: 'web',
          file_id: action.payload.fileId,
          file_ext: action.payload.fileExtension,
          mime_type: action.payload.mimeType,
          file_size: action.payload.size,
          type: action.payload.origin,
          success: action.payload.isSuccessful,
        };
      },
    )
    .match(
      [showMessage],
      (action) => {
        if (action.payload.type === POST_LIMIT_REACHED) {
          return postLimitReached;
        }
      },
      (action) => {
        let type = '';
        if (action.payload.type === POST_LIMIT_REACHED) {
          type = 'post';
        } else if (action.payload.type === POST_LIMIT_REACHED) {
          type = action.payload.props.isReply ? 'comment' : 'reply';
        }
        return {
          application_type: 'web',
          post_limit:
            POST_LIMITER_VALUES[getPostLimiter(state) as keyof typeof POST_LIMITER_VALUES] || 10,
          type,
        };
      },
    )
    .match(
      [userEventsShowEmptyState],
      () => emptyStateShown,
      (action) => {
        return {
          empty_state_type: action.payload.type,
          category_id: action.payload.categoryId,
        };
      },
    )
    .match(
      [setSavedAction],
      (action) => {
        if (action.payload.action === REACT_TO_POST) {
          return likeClicked;
        }
      },
      (action) => {
        switch (action.payload.action) {
          case REACT_TO_POST:
            const args = action.payload.args[0] as any;
            const { postId, reactionCode } = args as {
              postId: string;
              reactionCode: ReactionCode;
            };

            return {
              post_id: postId,
              reaction_type: ReactionCodeBIMap[reactionCode],
              flag: true,
              action: 'add',
              type: 'post',
              origin: feedTypeToTabName(getTabsOrigin(state)) || getCurrentOrigin(state),
            };
          default:
            return;
        }
      },
    )
    .match(
      [userEventsClickReaction],
      () => likeClicked,
      (action) => {
        const { subaction, postId, reactionCode, type } = action.payload;
        return {
          post_id: postId,
          reaction_type: ReactionCodeBIMap[reactionCode],
          flag: subaction !== 'REMOVE',
          action: subaction.toLocaleLowerCase(),
          type,
          origin: feedTypeToTabName(getTabsOrigin(state)) || getCurrentOrigin(state),
        };
      },
    )
    .match(
      [userEventsClickPublish],
      () => attemptToPublishPost,
      (action) => {
        return {
          post_id: action.payload.postId,
          type: action.payload.type,
          symbol_count: action.payload.symbolCount,
          attempt_type: action.payload.isEditing ? 'edit' : 'new',
        };
      },
    )
    .match(
      [setPostTypeFilter],
      () => postFilter,
      (action) => {
        const categorySlug = getRouteParams(state).categorySlug;
        const category = getCategoryBySlug(state, categorySlug);
        return {
          filter_by: action.payload === FILTER_SHOW_ALL ? 'all' : action.payload,
          category_id: category ? category._id : null,
          origin: 'posts_page',
        };
      },
    )
    .match(
      [userEventsPostCaptchaShown],
      () => captchaOnPostPublish,
      (action) => {
        return {
          captcha_step: 1,
          postType: 'post',
        };
      },
    )
    .match(
      [userEventsPostCaptchaResolved],
      () => captchaOnPostPublish,
      (action) => {
        const isResolved = action.payload;
        return {
          captcha_step: 2,
          postType: 'post',
          captcha_success: isResolved,
        };
      },
    )
    .match(
      [userEventsCommentCaptchaShown],
      () => captchaOnPostPublish,
      (action) => {
        return {
          captcha_step: 1,
          postType: 'comment',
        };
      },
    )
    .match(
      [userEventsCommentCaptchaResolved],
      () => captchaOnPostPublish,
      (action) => {
        const resolved = action.payload;
        return {
          captcha_step: 2,
          postType: 'comment',
          captcha_success: resolved,
        };
      },
    )
    .match(
      [hideGuidelinesSuccess],
      () => clickOnShowHideGuidelines,
      (action) => {
        const { type } = action.payload;
        return {
          flag: false,
          type: getGuidelinesType(type),
        };
      },
    )
    .match(
      [showGuidelinesSuccess],
      () => clickOnShowHideGuidelines,
      (action) => {
        const { type } = action.payload;
        return {
          flag: true,
          type: getGuidelinesType(type),
        };
      },
    )
    .match(
      [userEventsGuidelinesShown],
      () => shownGuidelines,
      (action) => {
        const { type, origin, categoryId } = action.payload;
        return {
          origin,
          category_id: categoryId,
          type: getGuidelinesType(type),
        };
      },
    )
    .match(
      [navigateToMainPageStart],
      () => forumTabClick,
      (action) => {
        return {
          origin: feedTypeToTabName(getTabsOrigin(state)),
          tab_name: getTabNameByFeedType(action.payload),
        };
      },
    )
    .match(
      [userEventsPostingDisabledShown],
      () => readOnlyMessageShown,
      () => {
        return {
          step: '1',
        };
      },
    )
    .match(
      [userEventsPostingDisabledClose],
      () => readOnlyMessageShown,
      (action) => {
        return {
          step: '2',
          option_value: action.payload ? 'make_active' : 'stay_read_only',
        };
      },
    )
    .match(
      [userEventsSearchFocused],
      () => clickOnSearchField,
      () => {
        return {
          origin: feedTypeToTabName(getTabsOrigin(state)),
        };
      },
    )
    .match(
      [userEventsSearchCleared],
      () => clickInSearchFieldX,
      () => {
        return {};
      },
    )
    .match(
      [userEventsSearchSuggestionsLoaded],
      () => searchTabDropListShowed,
      (action) => {
        return {
          origin: feedTypeToTabName(getTabsOrigin(state)),
          search_term: action.payload,
        };
      },
    )
    .match(
      [userEventsSearchSubmitted],
      () => clickSeeAllResultsInSearchField,
      (action) => {
        return {
          origin: feedTypeToTabName(getTabsOrigin(state)),
          search_term: action.payload.query,
          search_trigger: action.payload.location, // see_all_results / enter
        };
      },
    )
    .match(
      [interactionError],
      () => customErrorPageRendered,
      (action) => {
        return {
          error_data: JSON.stringify(action.payload),
        };
      },
    )
    .match(
      [pinPostRequest],
      (action) =>
        action.payload.expiresInMinutes !== undefined
          ? actionButtonPinPostConfirmationClick
          : undefined,
      (action) => {
        return {
          origin: feedTypeToTabName(getTabsOrigin(state)),
          post_id: action.payload.postId,
          value: getPinDurationValue(action.payload.expiresInMinutes),
        };
      },
    )
    .match(
      [userEventsPostPendingModalShown],
      () => postApprovalModalWindowOpen,
      (action) => {
        return {
          post_id: action.payload.postId,
          category_id: action.payload.categoryId,
        };
      },
    )
    .match(
      [userEventsPostPendingModalClose],
      () => postApprovalModalWindowClosed,
      (action) => {
        return {
          post_id: action.payload.postId,
          category_id: action.payload.categoryId,
          origin: action.payload.origin === 'close' ? 'X' : 'OK',
        };
      },
    )
    .execute(outerAction);
};

function createContentEntityData(
  action: { payload: CreatePostSuccess | UpdatePostSuccess | SearchResultComment | undefined },
  state: RootState,
  type: string,
  isEdit: boolean,
) {
  if (action.payload === undefined) {
    return;
  }
  const entity = action.payload;
  const emojiCount = getEmojiCount(entity);
  const mentionCount = getMentionCount(entity);
  const imageCount = getImageCount(entity);
  const fileCount = getFileCount(entity);
  const quoteCount = getQuoteCount(entity);
  const videoCount = getVideoCount(entity);
  const hashtagCount = getHashtagCount(entity);
  const gifCount = getGifCount(entity);
  const pollCount = getPollCount(entity);

  const guidelinesTypeFromStore = getDisplayGuidelinesTypeFromStore(state, entity.categoryId) as
    | typeof CATEGORY_GUIDELINES
    | typeof FORUM_GUIDELINES;

  const guidelinesType = {
    [CATEGORY_GUIDELINES]: 'category',
    [FORUM_GUIDELINES]: 'forum',
  }[guidelinesTypeFromStore];

  hasCustomVideo(entity);
  return {
    application_type: 'web',
    /* legacy bi naming, here 'post_id' points to the id of individual post or comment
       and 'parent_post_id' identifies under which post the comment exists
    */
    parent_post_id: entity.postId || '',
    post_id: (entity as CreatePostSuccess)?._id || (entity as Comment).id || '',
    category_id: (entity as CreatePostSuccess).categoryId,
    posts_format:
      (entity as CreatePostSuccess).postType || (getPost(state, entity.postId).postType as string),
    type,
    is_edited: isEdit,
    has_emoji: emojiCount > 0,
    has_image: imageCount > 0,
    has_mention: mentionCount > 0,
    mention_count: mentionCount as number,
    image_count: imageCount as number,
    file_count: fileCount as number,
    has_video: videoCount > 0,
    is_custom_video: videoCount > 0 && (hasCustomVideo(entity) as boolean),
    has_quote: quoteCount > 0,
    has_hashtag: hashtagCount > 0,
    hashtag_count: hashtagCount as number,
    has_gif: gifCount > 0,
    has_poll: pollCount > 0,
    is_admin: isOwner(state) as boolean,
    origin: getCreatePostOrigin(state, isEdit) as string,
    cta_origin: getBasicCreatePostCTAOrigin(state) as string,
    initiated_by: get(action, 'meta.initiatedBy', null) as string,
    guidelines_type: guidelinesType,
    captcha_used: get(action, 'meta.isCaptchaUsed', false) as string,
    was_category_selected: get(action, 'meta.wasCategorySelected', false),
  };
}

type AllActions =
  | ReturnType<typeof setHasReportedAppLoaded>
  | ReturnType<typeof userEventsClickCreatePostButton>
  | ReturnType<typeof subscribeSuccess>
  | ReturnType<typeof unsubscribeSuccess>
  | ReturnType<typeof changePage>
  | ReturnType<typeof fetchSearchSuccess>
  | ReturnType<typeof userEventsClickProfileLink>
  | ReturnType<typeof deletePostSuccess>
  | ReturnType<typeof deleteCategorySuccess>
  | ReturnType<typeof userEventsClickCreatePost>
  | ReturnType<typeof setRouterMatch>
  | ReturnType<typeof reportPostSuccess>
  | ReturnType<typeof pageOpened>
  | ReturnType<typeof createPostSuccess>
  | ReturnType<typeof updatePostSuccess>
  | ReturnType<typeof updatePostRequest>
  | ReturnType<typeof createPostRequest>
  | ReturnType<typeof actionsOpened>
  | ReturnType<typeof setPostsPageSorting>
  | ReturnType<typeof setSearchPageSorting>
  | ReturnType<typeof fileDownloadRequest>
  | ReturnType<typeof showMessage>
  | ReturnType<typeof userEventsShowEmptyState>
  | ReturnType<typeof setSavedAction>
  | ReturnType<typeof userEventsClickPublish>
  | ReturnType<typeof setPostTypeFilter>
  | ReturnType<typeof userEventsPostCaptchaShown>
  | ReturnType<typeof userEventsPostCaptchaResolved>
  | ReturnType<typeof userEventsCommentCaptchaShown>
  | ReturnType<typeof userEventsCommentCaptchaResolved>
  | ReturnType<typeof hideGuidelinesSuccess>
  | ReturnType<typeof showGuidelinesSuccess>
  | ReturnType<typeof userEventsGuidelinesShown>
  | ReturnType<typeof navigateToMainPageStart>
  | ReturnType<typeof userEventsPostingDisabledClose>
  | ReturnType<typeof userEventsPostingDisabledShown>
  | ReturnType<typeof userEventsSearchFocused>
  | ReturnType<typeof userEventsSearchCleared>
  | ReturnType<typeof userEventsSearchSuggestionsLoaded>
  | ReturnType<typeof userEventsSearchSubmitted>;
